export function enToRuLayout(text: string): string {
    const en = "qwertyuiop[]asdfghjkl;'zxcvbnm,./`QWERTYUIOP{}ASDFGHJKL:\"ZXCVBNM<>~@#$^&";
    const ru = "йцукенгшщзхъфывапролджэячсмитьбю.ёЙЦУКЕНГШЩЗХЪФЫВАПРОЛДЖЭЯЧСМИТЬБЮ,Ё\"№;:?";
    let result = "";
    for (let char of text) {
      const idx = en.indexOf(char);
      result += idx !== -1 ? ru[idx] : char;
    }
    return result;
  }

export function ruToEnLayout(text: string): string {
    const en = "qwertyuiop[]asdfghjkl;'zxcvbnm,./`QWERTYUIOP{}ASDFGHJKL:\"ZXCVBNM<>~@#$^&";
    const ru = "йцукенгшщзхъфывапролджэячсмитьбю.ёЙЦУКЕНГШЩЗХЪФЫВАПРОЛДЖЭЯЧСМИТЬБЮ,Ё\"№;:?";
    let result = "";
    for (let char of text) {
        const idx = ru.indexOf(char);
        result += idx !== -1 ? en[idx] : char;
    }
    return result;
}

/**
 * Функция для обработки кодов МКБ
 * Первая буква всегда должна быть английской, остальные - русскими
 * Пример: I20.0 -> I20.0, I20.0й -> I20.0й
 */
export function mkbCodeLayout(text: string): string {
    if (!text || text.length === 0) return text;
    
    const en = "qwertyuiop[]asdfghjkl;'zxcvbnm,./`QWERTYUIOP{}ASDFGHJKL:\"ZXCVBNM<>~@#$^&";
    const ru = "йцукенгшщзхъфывапролджэячсмитьбю.ёЙЦУКЕНГШЩЗХЪФЫВАПРОЛДЖЭЯЧСМИТЬБЮ,Ё\"№;:?";
    
    let result = "";
    
    for (let i = 0; i < text.length; i++) {
        const char = text[i];
        
        if (i === 0) {
            // Первая буква - всегда должна быть английской
            const idx = ru.indexOf(char);
            result += idx !== -1 ? en[idx] : char;
        } else {
            // Остальные символы - оставляем как есть (русские остаются русскими)
            result += char;
        }
    }
    
    return result;
}

/**
 * Функция для исправления кодировки из DBF файлов
 * Исправляет искаженные символы в тексте
 */
export function fixDbfEncoding(text: any): string {
    if (!text || typeof text !== 'string') return text;
    
    // Универсальный словарь для замены искаженных символов
    const replacements: { [key: string]: string } = {
        // Основные искажения
        'є': 'у',
        'яр': 'па',
        '·': ' ',
        // Заглавные буквы
        'À': 'А',
        'Á': 'Б',
        'Â': 'В',
        'Ã': 'Г',
        'Ä': 'Д',
        'Å': 'Е',
        'Æ': 'Ж',
        'Ç': 'З',
        'È': 'И',
        'É': 'Й',
        'Ê': 'К',
        'Ë': 'Л',
        'Ì': 'М',
        'Í': 'Н',
        'Î': 'О',
        'Ï': 'П',
        'Ð': 'Р',
        'Ñ': 'С',
        'Ò': 'Т',
        'Ó': 'У',
        'Ô': 'Ф',
        'Õ': 'Х',
        'Ö': 'Ц',
        '×': 'Ч',
        'Ø': 'Ш',
        'Ù': 'Щ',
        'Ú': 'Ъ',
        'Û': 'Ы',
        'Ü': 'Ь',
        'Ý': 'Э',
        'Þ': 'Ю',
        'ß': 'Я',
        // Строчные буквы
        'à': 'а',
        'á': 'б',
        'â': 'в',
        'ã': 'г',
        'ä': 'д',
        'å': 'е',
        'æ': 'ж',
        'ç': 'з',
        'è': 'и',
        'é': 'й',
        'ê': 'к',
        'ë': 'л',
        'ì': 'м',
        'í': 'н',
        'î': 'о',
        'ï': 'п',
        'ð': 'р',
        'ñ': 'с',
        'ò': 'т',
        'ó': 'у',
        'ô': 'ф',
        'õ': 'х',
        'ö': 'ц',
        '÷': 'ч',
        'ø': 'ш',
        'ù': 'щ',
        'ú': 'ъ',
        'û': 'ы',
        'ü': 'ь',
        'ý': 'э',
        'þ': 'ю',
        'ÿ': 'я',
        // Дополнительные искажения из нового вывода
        'èíúåêöèé': 'инъекций',
        'óïàê': 'упак',
        'Ðåá-Ôàðìà': 'Реб-Фарма',
        'Áåëàðóñü': 'Беларусь',
        'Òóðöèÿ': 'Турция',
        'óïàêîâàíî': 'упаковано',
        'àìïóë': 'ампул',
        'ìã': 'мг',
        'ìë': 'мл',
        'Æåëåçà': 'Железа',
        'ãèäðîêñèä': 'гидроксид',
        'ïîëèìàëüòîçàò': 'полимальтозат',
        'Ñðåäñòâà': 'Средства',
        'íà': 'на',
        'îñíîâå': 'основе',
        'òðåõâàëåíòíîãî': 'трехвалентного',
        'æåëåçà': 'железа',
        'äëÿ': 'для',
        'ïàðåíòåðàëüíîãî': 'парентерального',
        'ââåäåíèÿ': 'введения',
        'Ïðîòèâîàíåìè÷åñêèå': 'Противoанемические',
        'ñðåäñòâà': 'средства',
        'Ñåðòèôèêàò': 'Сертификат',
        'ÃÏ': 'ГП',
        'îò': 'от',
        'Àìèîäàðîí': 'Амиодарон',
        'òàáëåòêè': 'таблетки',
        'óïàêîâêà': 'упаковка'
    };
    
    let result = text;
    
    // Специальная обработка для символов, которые могут быть неправильно интерпретированы
    // Символ "к" может быть как буквой "к", так и "ь" в зависимости от контекста
    // Проверяем контекст - если после символа идет согласная, то это скорее всего "ь"
    result = result.replace(/к([бвгджзклмнпрстфхцчшщ])/g, 'ь$1');
    
    // Заменяем искаженные символы
    for (const [wrong, correct] of Object.entries(replacements)) {
        result = result.replace(new RegExp(wrong, 'g'), correct);
    }
    
    return result;
}